import { render, staticRenderFns } from "./LoginLogs.vue?vue&type=template&id=b8fca04a&scoped=true"
import script from "./LoginLogs.vue?vue&type=script&lang=ts"
export * from "./LoginLogs.vue?vue&type=script&lang=ts"
import style0 from "./LoginLogs.vue?vue&type=style&index=0&id=b8fca04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fca04a",
  null
  
)

export default component.exports